import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

  const footerLinks = [
    { label: "About", to: "/about" },
    { label: "Services", to: "/services" },
    { label: "Packages", to: "/packages" },
    { label: "Contact", to: "/contact" },
  ];

  const supportLinks = [
    { label: "Terms & Conditions", to: "/terms" },
    { label: "Privacy Policy", to: "/privacy-policy" },
  ];
  return (
    <div className="container-fluid footer py-5">
      <div className="container py-5">
        <div className="row g-5">
          {/* Contact Info */}
          <div className="col-md-6 col-lg-6 col-xl-4">
            <div className="footer-item d-flex flex-column">
              <h4 className="mb-4 text-white">Get In Touch</h4>
              <div className="d-flex align-items-start text-white mb-2">
                <i className="fas fa-home me-2 mt-1"></i>
                <span>Office No E 69, First Floor, your own Business center, Al Maskan Building, Near LuLu Hyper Market - Al Karama, Dubai.</span>
              </div>
              <div className="d-flex align-items-start text-white mb-2">
                <i className="fas fa-home me-2 mt-1"></i>
                <span>Office No E 69, First Floor, your own Business center, Aswaaq Community Mall - Al Mizhar, Dubai.</span>
              </div>
              <div className="d-flex align-items-start text-white mb-2">
                <i className="text-decoration-none fas fa-envelope me-2 mt-1"></i>
                <span>sales@theholidaybasket.com</span>
              </div>
              <div className="d-flex align-items-start text-white mb-2">
                <i className="text-decoration-none fas fa-phone me-2 mt-1"></i>
                <span>+971 52 325 6358</span>
              </div>

              {/* <a  className="mb-3 text-decoration-none"><i classNa+971 52 325 6358me="text-decoration-none fas fa-print me-2"></i> +012 345 67890</a> */}
              {/* <div className="d-flex align-items-center">
                <i className="fas fa-share fa-2x text-white me-2"></i>
                <a className="btn-square btn btn-primary rounded-circle mx-1" ><i className="fab fa-facebook-f"></i></a>
                <a className="btn-square btn btn-primary rounded-circle mx-1" ><i className="fab fa-twitter"></i></a>
                <a className="btn-square btn btn-primary rounded-circle mx-1" ><i className="fab fa-instagram"></i></a>
                <a className="btn-square btn btn-primary rounded-circle mx-1" ><i className="fab fa-linkedin-in"></i></a>
              </div> */}
            </div>
          </div>

          {/* Company Links */}

          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="mb-4 text-white">Company</h4>
              {footerLinks.map((item, i) => (
                <Link
                  to={item.to}
                  key={i}
                  className="text-decoration-none text-white mb-1"
                >
                  <i className="fas fa-angle-right me-2"></i> {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Support Links */}
          {/* <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="mb-4 text-white">Support</h4>
              {["Contact", "Legal Notice", "Privacy Policy", "Terms and Conditions", "Sitemap", "Cookie policy"].map((text, i) => (
                <a href="#" key={i} className='text-decoration-none'><i className="fas fa-angle-right me-2"></i> {text}</a>
              ))}
            </div>
          </div> */}
          <div className="col-md-6 col-lg-6 col-xl-3">
            <div className="footer-item d-flex flex-column">
              <h4 className="mb-4 text-white">Support</h4>
              {supportLinks.map((item, i) => (
                <Link
                  to={item.to}
                  key={i}
                  className="text-decoration-none text-white mb-1"
                >
                  <i className="fas fa-angle-right me-2"></i> {item.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Language / Currency / Payment */}
          <div className="col-md-6 col-lg-6 col-xl-2">
            <div className="footer-item">


              <h4 className="text-white mb-3">Payments</h4>
              <div className="footer-bank-card">
                {["cc-amex", "cc-visa", "cc-mastercard", "cc-paypal", "cc-discover"].map((icon, i) => (
                  <a href="#" key={i} className="text-white me-2">
                    <i className={`fab fa-${icon} fa-2x`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
